import { lazy } from 'react';


export const AllCourse = lazy(() => import('./AllCourse'));
